import contactNumber from "../data/contactNumber.js";

export const usePhoneNumber = () => {
  // Helper function to format phone number to pretty format: (XXX) XXX-XXXX
  const formatPhonePretty = (phone: string): string => {
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
    }
    return phone;
  };

  // Helper function to format phone number to tel: link format
  const formatPhoneTel = (phone: string): string => {
    const cleaned = phone.replace(/\D/g, "");
    return `tel:+${cleaned.startsWith("1") ? cleaned : "1" + cleaned}`;
  };

  const phoneNumber = contactNumber;
  const phoneNumberPretty = formatPhonePretty(contactNumber);
  const phoneNumberTel = formatPhoneTel(contactNumber);

  return {
    phoneNumber,
    phoneNumberPretty,
    phoneNumberTel,
  };
};
